var map = {
	"./CalculateForStaffLevelV3.graphql": "6d18",
	"./CalculateMultiplePayment.graphql": "2498",
	"./CalculatePayments.graphql": "22bf",
	"./ChangeSubscription.graphql": "a757",
	"./Company.graphql": "e3bf",
	"./CompanyAdmin.graphql": "fb6f",
	"./Demo.graphql": "4737",
	"./DownloadAllEmployeeReceipt.graphql": "2bd4",
	"./DownloadBonusAndDeductionHistory.graphql": "0c7a",
	"./DownloadCompanyReceipt.graphql": "540e",
	"./DownloadDetailedPayrollHistory.graphql": "31b0",
	"./DownloadEmployeeReceipt.graphql": "c097",
	"./DownloadPayrollHistorySummary.graphql": "b2e8",
	"./DownloadPayrollPreview.graphql": "9737",
	"./DownloadXLTemplate.graphql": "f34b",
	"./FetchBankAccounts.graphql": "0373",
	"./FetchCompaniesByAdminId.graphql": "49b9",
	"./FetchCompanyAdmin.graphql": "b132",
	"./FetchReferralCode.graphql": "280a",
	"./GetACompanyProduct.graphql": "51bc",
	"./GetAPIKey.graphql": "50f5",
	"./GetAllCompanyCall.graphql": "a0d6",
	"./GetAllSubscriptionPackages.graphql": "bd20",
	"./GetBonusAndDeductionHistory.graphql": "5fd3",
	"./GetCompanyContributions.graphql": "d3c0",
	"./GetCompanyKycInformation.graphql": "e316",
	"./GetCompanySubscription.graphql": "c18a",
	"./GetCompanySubscriptionV3.graphql": "6dd8",
	"./GetComplianceRegistration.graphql": "4292",
	"./GetComplianceRegistrationSummary.graphql": "14f1",
	"./GetComplianceTransactions.graphql": "e78d",
	"./GetComplianceTxnDetails.graphql": "ffd0",
	"./GetDetailedPayrollReport.graphql": "3a68",
	"./GetEmployeeProfile.graphql": "72b3",
	"./GetEmployeesCompliance.graphql": "d16a",
	"./GetKycInformation.graphql": "408a",
	"./GetPayrollAnalysis.graphql": "5eeb",
	"./GetPayrollReport.graphql": "41ce",
	"./GetSubscriptionCharges.graphql": "2c82",
	"./GetTaxForm.graphql": "fec8",
	"./ListActivities.graphql": "3f12",
	"./ListAllowance.graphql": "7d42",
	"./ListBonusAndDeduction.graphql": "06a3",
	"./ListBranches.graphql": "aa01",
	"./ListCompanyExec.graphql": "a296",
	"./ListCompanyProducts.graphql": "01dd",
	"./ListCompliance.graphql": "65e2",
	"./ListDepartments.graphql": "20d7",
	"./ListEmployeeBonusAndDeduction.graphql": "cec9",
	"./ListEmployees.graphql": "f3d9",
	"./ListLiteEmployeePaymentRecords.graphql": "d1a8",
	"./ListLoans.graphql": "ce02",
	"./ListPayrollAutomations.graphql": "325e",
	"./ListPayrollHistory.graphql": "1054",
	"./ListPrivileges.graphql": "80f7",
	"./ListRoles.graphql": "966d",
	"./ListSecurityQuestions.graphql": "cc3b",
	"./ListSecurityQuestionsTwoFa.graphql": "6891",
	"./ListTeamMembers.graphql": "46fc",
	"./ListWalletTransactions.graphql": "ad78",
	"./LoanContract.graphql": "83dc",
	"./PayclicksV3.graphql": "0680",
	"./PreviewCompliance.graphql": "b8e8",
	"./PreviewPayroll.graphql": "68c4",
	"./PreviewPayrollMultiple.graphql": "0687",
	"./SendDetailedPayrollReport.graphql": "536d",
	"./SendPayrollAnalysis.graphql": "0c43",
	"./SendPayrollReport.graphql": "26ef",
	"./VerifyPaystackPayment.graphql": "ce05",
	"./ViewCallDetail.graphql": "1f75",
	"./ViewCompany.graphql": "79fa",
	"./ViewCompanyTestKeys.graphql": "028e",
	"./ViewCompanyVirtualAccount.graphql": "c8ea",
	"./ViewInflowOutflowBalance.graphql": "1485",
	"./ViewLiteEmployeePaymentRecordForMonth.graphql": "d63c",
	"./ViewPayrollForMonthV3.graphql": "f9cd",
	"./ViewWalletBalance.graphql": "9434",
	"./ViewWalletReport.graphql": "8b56"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6ad";